import React from "react";
import styles from "./PendingPaymentCard.module.scss";
import { ReactComponent as PaymentPendingIcon } from "../../assets/images/payment-pending.svg";

type PendingPaymentCardProps = {
  paymentmethod: string;
};
const PendingPaymentCard = ({ paymentmethod }: PendingPaymentCardProps) => {
  return (
    <div className={styles.pending_transaction}>
      <PaymentPendingIcon />
      <h3>Payment Pending</h3>
      <p>
        Your payment is taking too long to confirm from the bank, we will email
        you once your payment has been confirmed.
      </p>
    </div>
  );
};

export default PendingPaymentCard;
